<template>
  <status-bar />

  <div
    class="tw-relative tw-flex tw-h-full tw-flex-col tw-items-center tw-justify-center tw-gap-8 tw-overflow-hidden tw-p-4 lg:tw-p-0"
    :class="{ 'tw-border-t-4 tw-border-orange-500': isStagingEnvironment }"
  >
    <router-link to="/">
      <img class="tw-w-44 lg:tw-w-60" src="/images/logo_no_tagline.svg" />
    </router-link>

    <div
      class="tw-w-full tw-max-w-lg tw-rounded-2xl tw-border tw-border-gray-200 tw-bg-white tw-p-4 lg:tw-px-20 lg:tw-py-16"
    >
      <slot />
    </div>

    <div class="tw-italic">Leerlingbespreking, portfolio en leerdoelen.</div>

    <div
      class="radial tw-pointer-events-none tw-absolute tw-bottom-0 tw-left-0 -tw-z-10 tw-aspect-square tw-w-[100vw] tw-translate-x-[-50%] tw-translate-y-[50%] tw-rounded-full md:tw-w-[1200px]"
    ></div>

    <img
      class="tw-absolute tw-left-3/4 tw-top-4 -tw-z-10 tw-w-10 -tw-translate-x-1/2 md:tw-top-24 md:tw-w-16"
      src="/images/brand-icons/plusses.svg"
    />
  </div>
</template>

<script setup lang="ts">
import StatusBar from "components/layout/StatusBar.vue";
import { isStagingEnvironment } from "composables/useHelpers";
</script>
